<template>
  <div class="sel">
      <el-form :inline="true" class="demo-form-inline" ref="formInline" :model="formInline">
      <el-form-item prop="managerName">
       <el-input v-model="formInline.managerName" placeholder="里程桩号名称"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">查询</el-button>
         <el-button type="primary" @click="">下载模板</el-button>
          <el-button type="primary" @click="">导入</el-button>
           <el-button type="primary" @click="addUsers">新增</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  props: {
    tableLabel:Array,
    tableData:Array,
  },
    data () {
      return {
      json_fields: {
        "头部-诊断名称": "name",    //常规字段
        "头部-联系电话": "phone.mobile", //支持嵌套属性
      },
      json_data: [
        {
          name: "损坏的组件一",
          city: "New York",
          country: "United States",
          birthdate: "1978-03-15",
          phone: {
            mobile: "1-541-754-3010",
            landline: "(541) 754-3010"
          }
        },
        {
          name: "损坏的组件二",
          city: "Athens",
          country: "Greece",
          birthdate: "1987-11-23",
          phone: {
            mobile: "+1 855 275 5071",
            landline: "(2741) 2621-244"
          }
        }
      ],
      json_meta: [
        [
          {
            " key ": " charset ",
            " value ": " utf- 8 "
          }
        ]
      ],

        radio: 1,
         options: [{
          value: '选项1',
          label: '黄金糕'
          }, {
            value: '选项2',
            label: '双皮奶'
          }, {
            value: '选项3',
            label: '蚵仔煎'
          }, {
            value: '选项4',
            label: '龙须面'
          }, {
            value: '选项5',
            label: '北京烤鸭'
          }],
        value: '',
        formInline: {
          value1:'',
          value2:'',
          jigou:'',
          managerName:'',
          man:'',
          access:'',
          status:''
        }
      };
    },
     methods: {
      onSubmit(formInline) {
        this.$parent.getList(this.formInline);
      },
      addUsers(){
        this.$parent.addUser();
      },
      checkMove(){
         this.$message({
          message: this.radio
        });
      },
      onResult(){
        this.$refs.formInline.resetFields()
      }
    },
}
</script>

<style lang="scss" scoped>
.sel {
    margin-top: 30px;
    padding: 0 30px;
    & /deep/ .el-input__inner {
      border-radius: 6px;
    }
    & /deep/ .el-input, .el-select {
      margin: 2.5px 5px;
    }
    & /deep/ .el-select {
      margin-left: 0;
      margin-right: 10px;
    }
    & /deep/ .el-button {
      color: #fff;
      width: 150px;
      height: 36px;
      line-height: 10px;
      border: 1px solid rgba(33,150,227,0.50);
      border-radius: 4px;
      margin: 0 10px;
      margin-top: 5px;
    }
  }
.demo-form-inline{
  margin-top: 1%
}
</style>
